import { facts } from "@/mocks/home";

export default function Facts() {
  return (
    <section id="facts" className="w-full bg-background-100 py-14 md:py-20">
      <div className="shell">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div className="max-w-xl">
            <p className="sec-eyebrow">瓜前补课</p>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
              吃瓜也讲门道
              <span className="text-accent-700">·冷知识专栏</span>
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              答题不只看热闹，本期带你看看题目背后的选题逻辑与传播规律，读完了再去答题更有底。
            </p>
          </div>
          <span className="chip w-fit">
            <i className="ri-news-line mr-1 text-sm text-primary-500" aria-hidden="true" />
            每周三更新
          </span>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-6 lg:grid-cols-3">
          {facts.map((f, idx) => (
            <article key={f.title} className="group overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <div className="relative h-44 w-full overflow-hidden md:h-48">
                <img
                  src={f.image}
                  alt={f.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute right-3 top-3 font-display text-4xl font-bold leading-none text-background-50/90">
                  0{idx + 1}
                </span>
              </div>
              <div className="p-5">
                <span className="inline-flex items-center rounded-full bg-accent-100 px-2.5 py-1 text-xs font-bold text-accent-800">
                  <i className="ri-sparkling-line mr-1 text-sm" aria-hidden="true" />
                  {f.tag}
                </span>
                <h3 className="mt-3 font-heading text-lg font-black leading-snug text-foreground-950">
                  {f.title}
                </h3>
                <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">{f.text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}